import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarGeral from "../assets/images/club.jpeg";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Geral() {
    useTrackPageView();
    useTimeOnPage();

    const handleWhatsappClick = async () => {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: "leads",
            category: "whatsapp",
            action: "click",
            label: "geral_cta_main",
        });

        await trackEvent("whatsapp_click", {
            buttonLocation: "geral_cta_main", // Corrigido a label analytics para bater com esta página
        });

        // AJUSTADO: Link limpo e válido para o grupo geral
        window.open("https://midiapromo.com/zap/promosclubeperfume", "_blank");
    };

    return (
        <LandingCategory
            avatar={avatarGeral}
            titleTop="CHEGA DE"
            titleBottom="PAGAR CARO EM PERFUMES!"
            highlightWord="PAGAR CARO EM PERFUMES!"
            members="100.000"
            description="Entre no nosso grupo VIP e receba as melhores promoções da internet todos os dias!"
            // AJUSTADO: Mesmo link válido aqui embaixo
            whatsappLink="https://midiapromo.com/zap/promosclubeperfume"
            telegramLink="https://t.me/seu-link"
            theme={themes.geral}
            onWhatsappClick={handleWhatsappClick}
        />
    );
}